'use client';

import { useMemo } from 'react';
import Container from '../../../components/Container';
import styles from './styles.module.scss';
import { CademyError } from '@shared/domain-shared';

export default function Error({ error }: { error: unknown }) {
    const cademyError = useMemo(() => {
        return CademyError.fromUnknown(error);
    }, [error]);

    return (
        <Container>
            <div className={styles.innerContainer}>
                <h1>Oops something went wrong</h1>
                <h2>{cademyError.title}</h2>
                {cademyError.detail ? <p>{cademyError.detail}</p> : null}
                <h2>What can I do?</h2>
                <p>Try reloading the page and trying the action again.</p>
            </div>
        </Container>
    );
}
